<button mat-menu-item color="primary" (click)="openModal()">
  <span>Batch update iOS native support flag</span>
</button>
